import React from "react";
import { SUB_DIRCTORY } from "../../../app_config";

const ParkingLocationFloorConfigurationsRoutes = [
  {
    path: `${SUB_DIRCTORY}/floor-configurations/:action/`,
    component: React.lazy(() => import("./addFloorConfigurations")),
  },
  {
    path: `${SUB_DIRCTORY}/floor-check-in`,
    component: React.lazy(() => import("./FloorCheckInList")),
  },
  {
    path: `${SUB_DIRCTORY}/floor-configurations`,
    component: React.lazy(() => import("./ParkingLocationFloorConfigurationsList.jsx")),
  },
];

export default ParkingLocationFloorConfigurationsRoutes;